module.exports = __webpack_public_path__ + "bf08da82ad57dd8c706a3410f81d0dec.png";